import { EventDetails } from '../types/event_details.types';
import { eventsPath } from '../../utilities/api_relative_paths';
import { checkStatus } from '../../utilities/fetch';
import { GetSpeakersResponse, GetSponsorsResponse } from '../../types/event.types';
import { createQueryString } from '../../utilities/utilities';
import pickBy from 'lodash/pickBy';
const NESTED_RESOURCE_PAGE_SIZE = 500;

const getEventNestedResource = (
  resource: string,
  eventId: number
): Promise<GetSpeakersResponse | GetSponsorsResponse> => {
  if (!eventId) return Promise.reject('Missing parameter: eventId');

  const filters = {
    page: { size: NESTED_RESOURCE_PAGE_SIZE },
  };

  return fetch(`${eventsPath}/${eventId}/${resource}${createQueryString(filters)}`)
    .then(checkStatus)
    .then((response) => response.json())
    .catch((error) => Promise.reject(error));
};

const postEventRegistration = (
  eventId: number,
  consultantId: number,
  questionForSpeaker?: string
): Promise<EventDetails> => {
  if (!eventId || !consultantId) return Promise.reject('Missing parameter');

  const body = pickBy({
    consultant_id: consultantId,
    questions: questionForSpeaker,
  });

  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return fetch(`${eventsPath}/${eventId}/attendees`, requestOptions)
    .then(checkStatus)
    .then((response) => response.json())
    .catch((error) => Promise.reject(error));
};

export { postEventRegistration, getEventNestedResource };
